import { toggleHiddenInsightsItem } from '@griply/utils';
import { useCallback } from 'react';
import { useUpdateInsightsSectionMutation } from 'shared/hooks/queries/use-update-insights-section-mutation';
import { useUser } from 'shared/hooks/use-user';
import { ID } from 'shared/types/id';
import { InsightSections } from 'shared/types/insights';

export const useToggleHiddenInsightsItem = (section: InsightSections) => {
  const { mutate } = useUpdateInsightsSectionMutation();
  const user = useUser();

  return useCallback(
    (id: ID) => {
      const newInsightsSection = toggleHiddenInsightsItem(
        user?.settings?.insights?.sections?.[section],
        id,
      );
      mutate({ id: section, section: newInsightsSection });
    },
    [mutate, section, user?.settings?.insights?.sections],
  );
};
